module.exports = __webpack_public_path__ + "img/end2end.c1bde54f.svg";